<template>
  <v-container>
    <v-dialog v-model="driver_edit_dialog" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="blue-grey">
          <v-btn icon dark @click.native="$router.push({name: 'DriversList'})"><v-icon>mdi-close</v-icon></v-btn>
          <v-toolbar-title>Detalhes do Motorista</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-if="!loading">
          
          <v-btn 
            large 
            rounded 
            :color="one_driver.data.attributes.status_id == active_id ? 'deep-orange' : 'success'" 
            class="white--text mb-3 mt-3" 
            @click="block_driver()" 
            block
          >
            <v-icon left>{{one_driver.data.attributes.status_id == active_id ? 'mdi-account-lock' : 'mdi-account-lock-open'}}</v-icon>
            {{one_driver.data.attributes.status_id == active_id ? 'BLOQUEAR MOTORISTA' : 'DESBLOQUEAR'}} 
          </v-btn>
      
          <v-expansion-panels multiple  v-if="one_driver != null" popout v-model="panel" flat active-class="elevation-4">
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">Informações básicas</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-row justify="space-around">
                    <v-col cols='12' class="d-flex">
                      <v-btn color="error" small class="ml-2" @click="() => {this.dialogs.info = true}"><v-icon samll left>mdi-pencil</v-icon>Editar</v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols='12' sm='6' md='4' v-if="one_driver.data.attributes.name != null">
                      <v-text-field :value="one_driver.data.attributes.name" label="Nome" readonly></v-text-field>
                    </v-col>
                    <v-col cols='12' sm='6' md='4' v-if="one_driver.data.attributes.cnh != null && one_driver.data.attributes.cnh != ''">
                      <v-text-field :value="one_driver.data.attributes.cnh" label="CNH" readonly></v-text-field>
                    </v-col>
                    <v-col cols='12' sm='6' md='4' v-if="one_driver.data.attributes.cpf != null && one_driver.data.attributes.cpf != ''">
                      <v-text-field :value="one_driver.data.attributes.cpf" label="CPF" v-mask="'###.###.###-##'" readonly></v-text-field>
                    </v-col>
                    <v-col cols='12' sm='6' md='4' v-if="one_driver.data.attributes.cnpj != null && one_driver.data.attributes.cnpj != ''">
                      <v-text-field :value="one_driver.data.attributes.cnpj" label="CNPJ" v-mask="'##.###.###/####-##'" readonly></v-text-field>
                    </v-col>
                    <template v-if="one_driver.data.attributes.attached_file_url">
                      <v-col cols='12' sm='12'>
                        <v-img :src="one_driver.data.attributes.attached_file_url" contain max-height="600px" max-width="1200px"
                          target="_blank"
                          @click="openImg"
                        ></v-img>
                      </v-col>
                    </template>
      
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">Endereço</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-row justify="space-around">
                    <v-col cols='12' class="d-flex">
                      <v-btn color="error" small class="ml-2" @click="() => {this.dialogs.address = true}"><v-icon small left>mdi-pencil</v-icon>Editar</v-btn>
                    </v-col>
                    <template v-if="one_driver.data.attributes.address != null">
                      <address-form :address="one_driver.data.attributes.address.data.attributes" read_only></address-form>
                    </template>
                    <AddressProofFiles
                      readonly
                      :address_proof_files_urls="one_driver.data.attributes.address_proof_files_urls || []"
                    ></AddressProofFiles>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">Contato</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-row justify="space-around">
                    <v-col cols='12' class="d-flex">
                      <v-btn color="error" small class="ml-2" @click="() => {this.dialogs.contacts = true}"><v-icon samll left>mdi-pencil</v-icon>Editar</v-btn>
                    </v-col>
                    <div v-if="one_driver.data.attributes.contacts != null">
                      <div v-for="(contact, idx) in one_driver.data.attributes.contacts.data" :key="idx">
                        <v-col cols="12" lg="12">
                          <contact-form :contact="contact.attributes" read_only></contact-form>
                        </v-col>
                        <v-col cols="12" lg="12">
                          <v-divider class="py-2" v-if="idx == 0"></v-divider>
                        </v-col>
                      </div>
                    </div>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
      
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">Forma de recebimento</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-row justify="space-around">
                    <v-col cols='12' class="d-flex">
                      <v-btn color="error" small class="ml-2" @click="dialogs.account = true"><v-icon small left>mdi-pencil</v-icon>Editar</v-btn>
                    </v-col>
                    <receipt-config-form :model="one_driver" is_readonly></receipt-config-form>
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel  style="border-bottom: solid #ddd 1px;" ripple>
              <v-expansion-panel-header class="red--text font-weight-bold">Modulos do motorista 3º</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container grid-list-xl>
                  <v-row justify="space-around">
                    <v-col cols="12">
                      <!-- <edit-driver-modules :driver="one_driver.data.attributes"></edit-driver-modules> -->
                      <EditSolutions :model="{text:'motoristas', API:'Driver', METHOD:'updateInfos'}" @update="handleRefresh" :model_modality_ids="one_driver.data.attributes.modality_ids"/>
                    </v-col>

                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

      
          <dialog-edit-driver-info
            :dialog="dialogs.info" 
            :driver="one_driver.data.attributes"
            @closeDialog="handleCloseDialog"
            @refresh="handleRefresh"
          ></dialog-edit-driver-info>
      
          <dialog-edit-driver-address 
            :dialog="dialogs.address" 
            show_address_proof
            :model_address="one_driver.data.attributes.address ? one_driver.data.attributes.address.data.attributes : address"
            :address_proof_files_urls="one_driver.data.attributes.address_proof_files_urls || []"
            @closeDialog="handleCloseDialog"
            @updated="handleRefresh"
            @addressProofUpdated="handleAddressProofUpdated"
          ></dialog-edit-driver-address>
      
          <dialog-edit-driver-contacts 
            :dialog="dialogs.contacts" 
            :driver="{...one_driver.data.attributes}"
            @closeDialog="handleCloseDialog"
            @refresh="handleRefresh"
          ></dialog-edit-driver-contacts>
      
          <dialog-edit-receipt 
            :dialog="dialogs.account" 
            @updated="handleRefresh" 
            @closeDialog="handleCloseDialog"
            :model="one_driver"
            MODEL_API="Driver"
            METHOD="updateInfos"
          ></dialog-edit-receipt>
        </v-card-text>

        <card-loading-transparent v-if="loading" class="pt-5"></card-loading-transparent>
      </v-card>
      <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Api from '@/api/index'

export default {
  name: 'EditDriver',
  components: { 
    FileAttachment: () => import("@/components/shared/FileAttachment.vue"),
    DialogEditReceipt: () => import("@/_backoffice/_registrations/components/shared/edit/DialogEditReceiptConfig.vue"),
    ReceiptConfigForm: () => import("@/_backoffice/_registrations/components/shared/forms/ReceiptConfigForm.vue"),
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
    ContactForm: () => import('@/_backoffice/_registrations/components/shared/forms/ContactForm.vue'),
    DialogEditDriverAddress: () => import('@/_backoffice/_registrations/components/shared/edit/DialogEditAddress.vue'),
    DialogEditDriverInfo: () => import('./DialogEditDriverInfo.vue'),
    DialogEditDriverContacts: () => import('./DialogEditDriverContacts.vue'),
    AddressProofFiles: () => import('@/_backoffice/_registrations/components/drivers/AddressProofFiles.vue'),
    EditSolutions: () => import("@/_backoffice/_registrations/components/shared/EditSolutions.vue"),
  },
  data() {
    return {
      driver_edit_dialog: true,
      loading: true,
      saving: false,
      panel: [0,1],
      driver_info: {},
      cnpj_account: [false, false],
      new_cnpj_account: [false, false],
      
      dialogs:{
        address: false,
        info: false,
        contacts: false,
        account: false,
      },
      one_driver: {},

      address: {
        id: null, 
        addr: null, 
        number: null, 
        complement: null, 
        neighborhood: null, 
        city: null, 
        state: null, 
        zip: null,
        addressable_type: 'Driver',
        addressable_id: this.$route.params.id ? this.$route.params.id : null
      }

    }
  },
  methods: {
    handleRefresh(){
      this.getDriver()
    },
    handleAddressProofUpdated(files) {
      if (this.one_driver?.data?.attributes) {
        this.one_driver.data.attributes.address_proof_files_urls = files
      }
    },
    openImg(){
      window.open(this.one_driver.data.attributes.attached_file_url, '_blank');
    },
    getDriver(){
      this.loading = true
      Api.Driver.show(this.$route.params.id).then(r=>r.data).then(r => {
        this.one_driver = r
      }).catch(err=>{
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    handleCloseDialog(kind){
      this.dialogs[kind] = false
    },
    block_driver() {
      let status_id = this.one_driver.data.attributes.status_id == this.active_id ? this.suspended_id : this.active_id
      this.saving = true
      Api.Driver.updateInfos({id: this.$route.params.id, status_id: status_id}).then(response => response.data).then(driver => {
        this.addNotification({type: 'success',  msg: `Motorista 3º atualizado com sucesso!`})
        this.one_driver.data.attributes.status_id = driver.data.attributes.status_id
      }).catch(function (error) {
        console.log(error);
        this.addNotification({type: 'success',  msg: `Ocorreu um erro, o motorista não pode ser bloqueado!`})
      }).finally(() => this.saving = false);      
    },
    
    ...mapActions({
      getOneDriver: 'Driver/show',
      updateDriver: 'Driver/update',
      getBanks: 'Bank/index',
      clearDriver: 'Driver/clearDriver',
      clearAllDrivers: 'Driver/clearAllDrivers',
      clearUpdateMessage: 'Driver/clearUpdateMessage',
      deleteAccount: 'BankAccount/delete',
      addNotification: 'Notification/add'
    })
  },
  computed: {
    active_id() {
      if (this.allStatuses) {
        return this.allStatuses.find(obj => obj.attributes.title == 'Active').id
      }
    },
    suspended_id() {
      if (this.allStatuses) {
        return this.allStatuses.find(obj => obj.attributes.title == 'Suspended').id
      }
    },
    ...mapState({
      // one_driver: state => state.Driver.one_driver,
      allStatuses: state => state.Status.allStatuses,
      updateConfirmation: state => state.Driver.updateConfirmation,
      updateMsg: state => state.Driver.updateMessage,
      accountMsg: state => state.BankAccount.errorMessage
    })
  },
  mounted () {
    this.getDriver();
  },
}
</script>

<style scoped>
h3 {
  -webkit-text-fill-color: red !important;
}

.bcom-red:hover {
  -webkit-text-fill-color: red !important;
}

.bcom-green:hover {
  -webkit-text-fill-color: limegreen !important;
}

.bcom-yellow:hover {
  /* -webkit-text-fill-color: #FFC107 !important; amber darken-1 */
  -webkit-text-fill-color: #673AB7 !important;
}

h4 {
  -webkit-text-fill-color: red !important;
}
</style>
